
 import React from "react";

import "../../assets/css/mission.css";



import { motion } from "framer-motion";

export default function Mission() {
  return (
    <section className="mv">

      {/* 🔥 Animated Background Text */}
      <motion.h1 
        className="bg-text"
        initial={{ y: 0 }}
        animate={{ y: [0, -30, 0] }}
        transition={{ duration: 10, repeat: Infinity }}
      >
        TRIP WORD
      </motion.h1>

      <div className="mv-container">

        {/* MISSION */}
        <motion.div 
          className="mv-box"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          whileHover={{ scale: 1.03 }}
        >
          <h2>Our Mission</h2>
          <p>
            To provide seamless travel experiences with complete planning,
            comfort, and customer satisfaction.
          </p>
        </motion.div>

        {/* VISION */}
        <motion.div 
          className="mv-box"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          whileHover={{ scale: 1.03 }}
        >
          <h2>Our Vision</h2>
          <p>
            To become a trusted travel partner across India and globally
            by delivering quality services and unforgettable journeys.
          </p>
        </motion.div>

      </div>

    </section>
  );
}